import React from 'react';
import {Link} from 'react-router-dom';
import {observer, inject} from 'mobx-react';
import {observe} from 'mobx';
import Input from 'blocks/Input';
import Select from 'blocks/Select';
import {COUNTIES} from './constants';
import {TARGET_AUDIENCES_MULTISELECT} from '../create_workshop/constants';
import AccordionModule from './create_module/AccordionModule';
import Collapsible from 'react-collapsible';
import AccordionHeader from 'blocks/accordion/AccordionHead';
import Switcher from 'blocks/Switcher';
import BigInput from 'blocks/BigInput';
// import TextEditor from './TextEditor';
import {TARGET_FILE_CONTENT_TYPES, TARGET_FILE_MAX_SIZE} from '../create_workshop/constants';
import _ from 'lodash';
import { SingleDatePicker } from 'react-dates';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import 'react-dates/lib/css/_datepicker.css';
import className from 'classnames';
import moment from 'moment'
// import { convertToRaw } from 'draft-js';
// import draftToHtml from 'draftjs-to-html';
import MultiSelectWrapper from 'blocks/MultiSelectWrapper';
import QuillEditor from 'components/create_workshop/QuillEditor';
import Textarea from "react-textarea-autosize";

@inject('regularWorkshopCreate')
@inject('alert')
@inject('deleteModal')
@inject('user')
@observer
export default class Content extends React.Component {

  state = {
    focusedInput: false,
    open: false,
    endOpen: false,
    focusEnd: false,
    opened: true,
    editorHtml: '',
    showPopup: false,
  };

  componentDidMount = () => {
    this.moduleKey = 10000;
    this.stateObserve = observe(this.props.regularWorkshopCreate, 'openedEntity', () => {
      let openedEntity = this.props.regularWorkshopCreate.openedEntity;
      if(openedEntity.type === 'in_person')
        this.setState({opened: true});
      else {
          this.setState({opened: false});
      }
    });
  };
  componentWillUnmount = () => {
    this.stateObserve();
  };

  handleChange = e => {
    this.props.regularWorkshopCreate.handleChange(e)
  };

  handleChangeSummary = e => {
    this.props.regularWorkshopCreate.handleChange({summary: e.target.value})
  };

  setOpen = ({ open }) => {
    this.setState({ open });
  };

  toggleOpen = () => {
    this.setState({
      open: !this.state.open
    });
  };

  addMoreInfo = e => {
    let file = e.target.files[0];
    if(file.size > TARGET_FILE_MAX_SIZE || !TARGET_FILE_CONTENT_TYPES.includes(file.type)){
      this.props.alert.info('File invalid')
    }
    else {
      if (e.target.files && e.target.files[0]) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onload = e => {
          let newWorkshop = _.assign({}, {
            more_info: file,
            file_name: file.name,
            file_size: file.size
          });
          this.props.regularWorkshopCreate.handleChange(newWorkshop)
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };

  setOpenEnd = data => {
    this.setState({endOpen: !this.state.endOpen});
  };


  deleteFile = () => {
    if(this.props.regularWorkshopCreate.workshop.more_info === 1){
      this.props.deleteModal.eventDelete({type: 'file', fileTo: 'workshop'})
    }
    else
      this.props.regularWorkshopCreate.handleChange({more_info: null})
  };

  handleChangeMultiselect = data => {
    this.props.regularWorkshopCreate.handleChangeTargetAudience(data.target_audience)
  };

  handler = () => {
    if(this.props.regularWorkshopCreate.openedEntity.type === 'in_person') {
      this.props.regularWorkshopCreate.handleChangeOpenedEntity({type: 'none', id: 0});
    }
    else
      this.props.regularWorkshopCreate.handleChangeOpenedEntity({type: 'in_person'})
  };

  addEmptyModule = () => {
    let key = this.moduleKey++;
    this.props.regularWorkshopCreate.addEmptyModule(key);
    console.log(key)
    this.props.regularWorkshopCreate.handleChangeOpenedEntity({type: 'module', id: key });
  };

  render(){
    let workshop = this.props.regularWorkshopCreate.workshop;
    let errors = this.props.regularWorkshopCreate.errors;


    let newCaption = '';
    let description = workshop.description;
    if(description !== '' ) {
      newCaption = document.createElement('div');
      // newCaption.innerHTML = description.replace(/<\/p>/gm, ' ').replace(/<(?:.|\n)*?>/gm, '');
      newCaption.innerHTML = description;
      newCaption = newCaption.textContent;
    }
    if(!_.isEmpty(newCaption) )
      newCaption = newCaption.replace(/\s/g,'');


    const EMPTY_MORE_INFO = (
      <label htmlFor="more_info">
      <li className="file-item">
      <i className="ic-upload-ico file-icon"/>
      <div className="file-link">
        <input type="file" style={{display: 'none'}}
               id="more_info" name="more_info" onChange={this.addMoreInfo}/>
        <span className="file-link-size">Formats allowed:</span>
        <span className="file-link-size">PDF, Word (Max size 5MB)</span>
      </div>
    </li>
      </label>);

    const FILE_PREVIEW = (<li className="file-item">
      <div className="file-item-inner">
        <i className="file-icon ic-file-ico"/>
        <div className="file-link">
          <p className="file-link-active">{workshop.file_name}</p>
          <p className="file-link-size">{parseInt(workshop.file_size / 1000)} KB</p>
        </div>
      </div>
      <span onClick={this.deleteFile} className="file-delete">
        <i className="ic-close-ico"/>
        </span>
    </li>);

    const data ={head: {
      label: !!this.props.regularWorkshopCreate.workshop.title ? this.props.regularWorkshopCreate.workshop.title : 'Workshop Title',
      icon: 'ic-flag-ico',
      caption: !!newCaption ? newCaption.substr(0,100) : 'Workshop description',
      withBtn: false,
      open: this.state.opened
    }};

    const trigger =  <div className={className({'module-has-error': !_.isEmpty(this.props.regularWorkshopCreate.getErrors()) })}> <AccordionHeader
      label={data.head.label}
      icon={data.head.icon}
      number={0}
      caption={data.head.caption}
      withBtn={data.head.withBtn || false}
      btn={{}}
    /></div>;

    return(
      <div className="col-12 col-md-9 pull-md-3 customregular-dates">
        <div className="regular-workshop-content">
          <div className="workshop-module gutter">
            <Collapsible
              className="accordion-item"
              openedClassName="accordion-item is-active"
              open={data.head.open}
              trigger={trigger}
              handleTriggerClick={this.handler}>
              <div className="accordion workshop-creator">
                <div>
                  <div className="accordion-item">
                    <div className="accordion-head">
                      <span className="accordion-number"/>
                      <div className="accordion-caption"/>
                    </div>
                    <div className="accordion-content">
                      <div className="row">
                        <div className="col-8">
                          <div className="accordion-content-block">
                            <p className="label">Online Workshop Or Regular (Offline) Workshop Or Live Webinar?</p>
                            <Link to='/createwebinar'>
                              <span className="btn bordered empty grey-empty">Live Webinar</span>
                            </Link>
                            <Link to="/createworkshop">
                            <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>ONLINE WORKSHOP</span>
                            </Link>
                            <span className="btn bordered prime" style={{backgroundColor: '#00c0c3', marginLeft: 10}}>REGULAR</span>
                            {/* {this.props.user.getUser().role === 'admin' && */}
                              <Link to={{pathname: '/createpublicwebinar'}}>
                                <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>PUBLIC WEBINARS</span>
                              </Link>
                            {/* } */}
                            {/* {this.props.user.getUser().role === 'admin' && */}
                              <Link to='/createpublicworkshop'>
                                <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>PUBLIC WORKSHOPS</span>
                              </Link>
                            {/* } */}
                            {this.props.user.getUser().role === 'admin' &&
                              <Link to='/createorganization'>
                                <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>Organisations Webinars</span>
                              </Link>
                            }
                            {this.props.user.getUser().role === 'admin' &&
                              <Link to='/createorganizationworkshop'>
                                <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>Organisations Workshops</span>
                              </Link>
                            }
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center">

                        <div className="col-2">
                          <div className={className('accordion-content-block accordion-content-block-date', {'active-date': workshop.start_date,'dates-error': errors.start_date })}>

                              <SingleDatePicker
                                showClearDate={true}
                                displayFormat={'DD/MM/YYYY'}
                                placeholder="Start date"
                                date={workshop.start_date || null}
                                numberOfMonths={1}
                                onDateChange={(startDate) => {
                                  this.props.regularWorkshopCreate.handleChange({start_date: startDate});
                                  this.setState({focusedInput: false})
                                  }
                                }
                                focused={this.state.focusedInput}
                                onFocusChange={ () => {
                                    this.setState({focusedInput: !this.state.focusedInput})
                                }}
                              />
                            <span className="error">Empty</span>


                          </div>

                        </div>
                        <div className="col-1">
                          <div className={className('accordion-content-block time', {'active-date': workshop.start_time, 'dates-error': errors.start_time })}>
                            <TimePicker open={this.state.open}
                                        onOpen={this.setOpen}
                                        onClose={this.setOpen}
                                        value={workshop.start_time || null}
                                        showSecond={false}
                                        placeholder="Time"
                                        onChange={value => value && this.props.regularWorkshopCreate.handleChange({start_time: value})}/>
                            <span className="error">Empty</span>
                          </div>
                        </div>
                        <div className="col-1">
                          <span className="border"/>
                        </div>
                        <div className="col-2">
                          <div className={className('accordion-content-block accordion-content-block-date',
                            {'active-date': workshop.end_date, 'dates-error': errors.end_date })}>
                            <SingleDatePicker
                              showClearDate={true}
                              placeholder="End date"
                              displayFormat={'DD/MM/YYYY'}
                              numberOfMonths={1}
                              date={workshop.end_date || null}
                              onDateChange={(startDate) => {
                                this.props.regularWorkshopCreate.handleChange({end_date: startDate});
                                this.setState({focusEnd: false})
                              }
                              }
                              focused={this.state.focusEnd}
                              onFocusChange={ () => {
                                this.setState({focusEnd: !this.state.focusEnd})
                              }}
                            />
                            <span className="error">Empty</span>
                          </div>
                        </div>
                        <div className="col-1">
                          <div className={className('accordion-content-block time',
                            {'active-date': workshop.end_time, 'dates-error': errors.end_time})}>
                            <TimePicker open={this.state.endOpen}
                                        onOpen={this.setOpenEnd}
                                        onClose={this.setOpenEnd}
                                        value={workshop.end_time || null}
                                        showSecond={false}
                                        placeholder="Time"
                                        onChange={value => value && this.props.regularWorkshopCreate.handleChange({end_time: value})}/>
                            <span className="error">Empty</span>

                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5">
                          <div className="accordion-content-block">
                            <Input name="venue_name"
                                  type="text"
                                  value={workshop.venue_name}
                                  handleChange={this.handleChange}
                                  placeholder="Venue name"
                                  error={errors.venue_name}/>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="accordion-content-block">
                            <Select
                              aditionalStyles={{maxHeight: 300,
                                overflow: 'auto'}}
                              elements={COUNTIES}
                              placeholder="County"
                              label="Select County"
                              name="venue_county"
                              value={workshop.venue_county}
                              handleChange={this.handleChange}
                              errors={errors.venue_county}/>
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="accordion-content-block">
                            <Input name="venue_postcode"
                                  type="text"
                                  value={workshop.venue_postcode}
                                  handleChange={this.handleChange}
                                  placeholder="Postcode"
                                  error={errors.venue_postcode}/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="accordion-content-block">

                            <Input name="venue_address"
                                  type="text"
                                  value={workshop.venue_address}
                                  handleChange={this.handleChange}
                                  placeholder="Address"
                                  error={errors.venue_address}/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-5 regular-customize-select">
                          <div className="accordion-content-block" style={{ marginTop: 27,
                            marginBottom: 0
                          }}>
                            <MultiSelectWrapper
                              elements={TARGET_AUDIENCES_MULTISELECT}
                              placeholder="Suitable for"
                              label="Suitable for"
                              name="target_audience"
                              value={workshop.target_audience}
                              handleChange={this.handleChange}
                              errors={errors.target_audience}
                            />
                          </div>
                        </div>
                        <div className="col-2 regular-switcher">
                          <Switcher name="cpd_hours"
                                    value={workshop.cpd_hours}
                                    placeholder="CPD Hours"
                                    notChoosenText="No"
                                    inputName="how_many_hours"
                                    inputValue={workshop.how_many_hours}
                                    handleChange={this.handleChange}
                                    errors={errors.how_many_hours}/>
                        </div>
                        <div className="col-2 regular-switcher">
                          <Switcher name="fee"
                                    value={workshop.fee}
                                    placeholder="Workshop fee"
                                    inputName="cost"
                                    notChoosenText="No Fee"
                                    inputValue={workshop.cost}
                                    handleChange={this.handleChange}
                                    errors={errors.cost}/>
                        </div>
                        <div className="col-2 regular-switcher">
                        <Switcher name="limited_purchase"
                                    value={workshop.limited_purchase}
                                    placeholder="Quantity"
                                    inputName="tickets_count"
                                    notChoosenText="No"
                                    inputValue={workshop.tickets_count}
                                    handleChange={this.handleChange}
                                    errors={errors.tickets_count}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="accordion-content-block">
                            <BigInput name="title"
                                  type="text"
                                  value={workshop.title}
                                  handleChange={this.handleChange}
                                  placeholder="Workshop title"
                                  error={errors.title}/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className={className({'col-12': true, 'has-error': errors.summary}) }>
                          <p className="label">Summary</p>
                          <Textarea
                            id="summary"
                            minRows={2}
                            className='animate-input'
                            value={workshop.summary}
                            onChange={this.handleChangeSummary}
                            style={{lineHeight: 2}}
                            placeholder={'Enter text here. Max 150 Characters'}
                            maxLength="150"
                          />
                          <span className="error-text" style={{color: '#e91e63'}}>{errors.summary}</span>
                        </div>
                      </div>
                      <div className="row">
                        <div className={className({'col-12': true, 'has-error': errors.description }) }>
                          <div className="accordion-content-block">
                            <p className="label">Workshop Description</p>

                            <QuillEditor
                                showToolbar={true}
                                onChange={(value) => {this.props.regularWorkshopCreate.handleChange({description: value})}}
                                value={workshop.description}
                                placeholder={'Enter text here'}
                              />

                          {/* <TextEditor description={workshop.description}
                                      onChange={this.handleChange}
                                      type="workshop"/> */}


                            <span className="text-editor-counter">{newCaption.length}/5000</span>
                            <span className="error-text" style={{color: '#e91e63'}}>{errors.description}</span>

                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <div className="accordion-content-block">
                            <p className="label">Upload more info (optional)</p>
                            <ul className="file-list editing">
                              {workshop.more_info ? FILE_PREVIEW : EMPTY_MORE_INFO}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Collapsible>
          </div>

          <div className="workshop-module gutter">
              <div className="accordion">
                {this.props.regularWorkshopCreate.getModules().map( el => <AccordionModule id={el.key} key={el.key} />)}
              </div>
            </div>
          { ( (this.props.regularWorkshopCreate.workshop.workshop_state === 'new_workshop' && this.props.regularWorkshopCreate.workshop.add_modules) || (this.props.regularWorkshopCreate.workshop.access_type==='owner' && this.props.regularWorkshopCreate.workshop.add_modules) || this.props.user.getUser().role === 'admin') &&
            !this.props.regularWorkshopCreate.workshop.bought &&
            <div className="btn-holder align-center">
              <div className="btn bordered white-bg add-modules" onClick={this.addEmptyModule}>ADD MODULE</div>
            </div>
          }
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/create_regular_workshop/Content.jsx